/**
 * EN content for the "Nice – Monaco" private excursion.
 *
 * Role: English translation of the FR fiche (slugs/nice-monaco.ts), typed
 * `ExcursionPage` so the shared ExcursionSlugView renders it identically.
 * Dependencies: slug-excursions (type), destination image asset.
 * The slug stays a proper-noun place name → mirrored from FR ("nice-monaco").
 */
import type { ExcursionPage } from "../slug-excursions";
import monaco from "@/assets/images/excursions/destinations/monaco.webp";

const page: ExcursionPage = {
  slug: "nice-monaco",
  hero: {
    title: "Nice – Monaco Excursion",
    subtitle:
      "Discover the French Riviera between Nice and the Principality of Monaco with a private chauffeur.",
    ctaPrimaryHref: "/en/reservation",
    ctaPrimaryLabel: "Book now",
    ctaSecondaryHref: "/contact",
    ctaSecondaryLabel: "Get a quote",
    image: monaco,
  },
  generic: {
    heading: "Mediterranean Panorama",
    paragraphs: [
      "Set off from Cannes to explore Nice and its Promenade des Anglais, then head for Monaco and the Rock.",
    ],
  },
  highlights: {
    title: "Highlights",
    items: [
      {
        text: "Promenade des Anglais, the Castle Hill and the old town of Nice",
      },
      {
        text: "Principality of Monaco: the Rock, casino, gardens and Port Hercule",
      },
      {
        text: "Panoramic coastal roads, photo stops and gourmet suggestions",
      },
      { text: "Flexible departure and return in Cannes and nearby" },
    ],
  },
  itinerary: {
    title: "Sample itinerary",
    steps: [
      {
        title: "Departure from Cannes",
        description: "Pick-up at the address of your choice.",
      },
      {
        title: "Nice",
        description: "Promenade des Anglais, old town, market (day dependent).",
      },
      {
        title: "Monaco",
        description: "The Rock, casino, harbour, free time.",
      },
      {
        title: "Return to Cannes",
        description: "Comfortable and punctual journey.",
      },
    ],
  },
  practical: {
    title: "Practical information",
    items: [
      {
        label: "Duration",
        value: "4 to 8 hours depending on your wishes (suggested: 6h)",
      },
      { label: "Departure", value: "Cannes and surrounding area" },
      {
        label: "Included",
        value: "Private chauffeur, water, Wi-Fi, tailored itinerary",
      },
      {
        label: "Option",
        value: "Free time for shopping / museum subject to opening hours",
      },
    ],
  },
  seo: {
    title: "Nice – Monaco Excursion from Cannes | Private Chauffeur",
    description:
      "Private full-day excursion from Cannes to Nice and Monaco with a chauffeur: Promenade des Anglais, the Rock, casino and panoramic coastal roads.",
    canonical: "/en/excursions/nice-monaco",
  },
};

export default page;
